import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const container = css`
  text-align: center;
  padding: 1.5rem;
  border-radius: 0.5rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    max-width: 25rem;
    width: 100%;
    margin: 0 auto;
  }
`;

export const title = css`
  margin-bottom: 0.5rem;
`;

export const description = css`
  margin-bottom: 1rem;
`;

export const benefits = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  text-align: left;
`;
